import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerYoutubeCompareAllPostsInDate.graphql';
import { Query, QueryinfluencerYoutubeCompareAllPostsInDateArgs } from '../../__generated__/globalTypes';

export const useInfluencerYoutubeCompareAllPostsInDateQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerYoutubeCompareAllPostsInDateArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerYoutubeCompareAllPostsInDateArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerYoutubeCompareAllPostsInDateLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerYoutubeCompareAllPostsInDateArgs>
): QueryResult<Query, QueryinfluencerYoutubeCompareAllPostsInDateArgs> & {
  getInfluencerYoutubeCompareAllPostsInDate: LazyQueryExecFunction<
    Query,
    QueryinfluencerYoutubeCompareAllPostsInDateArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerYoutubeCompareAllPostsInDate, result] = useLazyQuery<
    Query,
    QueryinfluencerYoutubeCompareAllPostsInDateArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerYoutubeCompareAllPostsInDate, ...result };
};

export const useInfluencerYoutubeCompareAllPostsInDatePromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerYoutubeCompareAllPostsInDate = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerYoutubeCompareAllPostsInDateArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerYoutubeCompareAllPostsInDateArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerYoutubeCompareAllPostsInDate };
};
// Suspense Query Hooks
export const useInfluencerYoutubeCompareAllPostsInDateSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerYoutubeCompareAllPostsInDateArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerYoutubeCompareAllPostsInDateArgs>(QUERY, {
    ...options
  });

  return result;
};
